<template>
	<div class="app-top-toolbar ol-unselectable ol-control">
	<!-- 	<button @click="change_layer('map')">Map</button>
		<button @click="change_layer('satellite')">Satellite</button> -->



		<select class="app-floor-control form-control" v-model="floor_level">
			<option value="*">View all levels</option>
			<option v-for="item in floor_levels" :value="item">Level {{item}}</option>
		</select>

		<select class="app-layer-control form-control ml-1" v-model="layer">
			<option value="satellite">Satellite</option>
			<option value="map">Map</option>
		</select>


	</div>
</template>

<script>
	export default {
		name: 'LayerToolbar',
		data: function() {
			return {

			}
		},
		computed: {
			floor_level: {
				get () {
					return this.$store.state.floor_level
				},
				set (value) {
					this.$store.commit('setState', ['floor_level', value])
				}
			},
			map() {
				return this.$store.state.map.map
			},
			layers() {
				return this.$store.state.map.layers
			},
			floor_levels() {
				let floor_levels = {};
				for (let i in this.$store.state.zones) {
					floor_levels[this.$store.state.zones[i].floor_level] = this.$store.state.zones[i].floor_level
				}

				return floor_levels;
			},
			drawLayer() { return this.$store.state.map.drawLayer },
			features() { return this.$store.state.features },
			layer: {
				get() { return this.$store.state.base_layer},
				set(value) { this.$store.commit('setState', ['base_layer', value])}
			}
		},
		watch: {
			floor_level() {
				this.floorVisibility();
			},
			layer: {
				handler() {
					if (this.layer == 'map') {
						this.layers[1].setVisible(true);
						this.layers[0].setVisible(false);
					}
					else {
						this.layers[1].setVisible(false);
						this.layers[0].setVisible(true);
					}
				},
				immediate: true
			}
		},
		mounted: function(){
			this.floorVisibility()
		},
		methods: {
			floorVisibility() {
				var that = this;
				this.map.getLayers().forEach(function (layer) {
					if (layer.get('type') != 'floor') return;

					if (that.floor_level == '*') layer.setVisible(true);
					else layer.setVisible((layer.get('floor_level') == that.floor_level));
				});

				for (var i in this.features) {
					var feature = this.features[i];
					if (this.floor_level == '*') feature.setStyle()
					else if (feature.floor_level == this.floor_level) feature.setStyle()
					else feature.setStyle(new ol.style.Style({'zIndex': -1}));
				}
			}
		}
	}
</script>
